/* hs-eslint ignored failing-rules */
/* eslint-disable promise/catch-or-return */

'use es6';

import { Fragment, useEffect } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import AbDropdownControls from 'page-editor-ui/components/AbDropdownControls';
import BestPracticesPopover from 'page-editor-ui/components/BestPracticesPopover';
import ContentRoutes from 'ContentUtils/Routes';
import { getTotalNumberOfActiveAbVariations } from 'ContentEditorUI/redux/selectors/abTestSelectors';
import { isNewAbTest, removeTemporaryNewAbTestBitIfNeeded } from 'ContentEditorUI/utils/temporaryLocalStorageState';
import { getCategoryId } from 'ContentEditorUI/redux/selectors/contentReadOnlyDataSelectors';
import { getAbActiveVariantId, getAbActiveVariantName, getAbMasterId, getAbMasterName, getIsABVariant, getIsAbTest } from 'ContentEditorUI/redux/selectors/abTestSelectors';
import { getHasUnsavedChanges } from 'ContentEditorUI/redux/selectors/saveDataSelectors';
import { autoSave as autoSaveAction } from 'page-editor-ui/redux/actions/pageSaveActions';
import { getHasPermissionsToCreateOrEditABTest } from 'ContentEditorUI/redux/selectors/authSelectors';
import { TestVariationTours } from '../components/TestVariationTours';
import UIFlex from 'UIComponents/layout/UIFlex';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const mapStateToProps = state => ({
  abActiveVariantId: getAbActiveVariantId(state),
  abActiveVariantName: getAbActiveVariantName(state),
  abMasterId: getAbMasterId(state),
  abMasterName: getAbMasterName(state),
  categoryId: getCategoryId(state),
  isAbTest: getIsAbTest(state),
  isVariant: getIsABVariant(state),
  totalNumberOfActiveAbVariations: getTotalNumberOfActiveAbVariations(state),
  hasUnsavedChanges: getHasUnsavedChanges(state),
  hasPermissionsToCreateOrEditABTest: getHasPermissionsToCreateOrEditABTest(state)
});
const PageAbControlsContainer = ({
  autoSave,
  categoryId,
  hasUnsavedChanges,
  abActiveVariantId,
  abActiveVariantName,
  abMasterId,
  abMasterName,
  isAbTest,
  isVariant,
  totalNumberOfActiveAbVariations,
  hasPermissionsToCreateOrEditABTest
}) => {
  const shouldShowVariationControls = isAbTest && totalNumberOfActiveAbVariations > 1;
  useEffect(() => {
    removeTemporaryNewAbTestBitIfNeeded();
  }, []);
  const handleClick = pageId => {
    if (hasUnsavedChanges) {
      autoSave().then(() => {
        window.location = ContentRoutes.edit(pageId, categoryId);
      });
    } else {
      window.location = ContentRoutes.edit(pageId, categoryId);
    }
  };
  function renderPopover() {
    return /*#__PURE__*/_jsx(BestPracticesPopover, {
      showInitialPopover: isNewAbTest(),
      test: "ab"
    });
  }
  return /*#__PURE__*/_jsx(Fragment, {
    children: shouldShowVariationControls && /*#__PURE__*/_jsx(TestVariationTours, {
      name: abMasterName,
      children: /*#__PURE__*/_jsxs(UIFlex, {
        align: "center",
        children: [/*#__PURE__*/_jsx(AbDropdownControls, {
          abActiveVariantId: abActiveVariantId,
          abMasterId: abMasterId,
          isVariant: isVariant,
          masterName: abMasterName,
          onClick: handleClick,
          variantName: abActiveVariantName,
          hasPermissionsToCreateOrEditABTest: hasPermissionsToCreateOrEditABTest
        }), /*#__PURE__*/_jsx("span", {
          className: "m-left-1",
          children: renderPopover()
        })]
      })
    })
  });
};
PageAbControlsContainer.propTypes = {
  abActiveVariantId: PropTypes.number,
  abActiveVariantName: PropTypes.string,
  abMasterId: PropTypes.number,
  abMasterName: PropTypes.string,
  categoryId: PropTypes.number.isRequired,
  isAbTest: PropTypes.bool.isRequired,
  isVariant: PropTypes.bool.isRequired,
  totalNumberOfActiveAbVariations: PropTypes.number.isRequired,
  hasUnsavedChanges: PropTypes.bool.isRequired,
  autoSave: PropTypes.func.isRequired,
  hasPermissionsToCreateOrEditABTest: PropTypes.bool.isRequired
};
export default connect(mapStateToProps, {
  autoSave: autoSaveAction
})(PageAbControlsContainer);